$(function () {

  // SHOW-HIDE STEP-1 FORM
  $('.label-autonomo,.label-empresa').click(function () {
    $('.form-step1 p').css('opacity', '1');
    $('.input-container.step1').show('fast');
  });

  $(document).click(function () {
    // SHOW STEP-2 FORM
    if ($('.phone').hasClass('has-value') && $('.name').hasClass('has-value') && $('.phone').hasClass('has-value') && $('.email').hasClass('has-value')) {
      $('.form-step2 p').css('opacity', '1');
      $('.input-container.step2').show('fast');
    }
    // CHANGE BACKGROUND CAROUSEL
    // if ($('.active .item').hasClass('comisiones')) {
    //   $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190502_altaremotaempresa_01.jpg")no-repeat center center').css('background-size', 'cover');
    // }
    // else if ($('.active .item').hasClass('tarjetas')) {
    //   $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190212_altaremotaempresa_02.jpg")no-repeat center center').css('background-size', 'cover');
    // }
    // else if ($('.active .item').hasClass('tpv')) {
    //   $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190528_altaremotaempresa_03.jpg")no-repeat center center').css('background-size', 'cover');
    // }
    // else if ($('.active .item').hasClass('financiacion')) {
    //   $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/repository/190506_altaremotaempresa_04.jpg")no-repeat center center').css('background-size', 'cover');
    // }
  });

  var owl = $('.owl-carousel');
  owl.owlCarousel({
    loop: true,
    nav: true,
    dots: true,
    items: 1,
  });

  // GET PARAM.URL - CHANGE BACKGROUND
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  var slide = getUrlParameter('sl');
  if (slide == 'comisiones') {
    $('.owl-stage').trigger('to.owl.carousel', [0, 1]);
    // $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190502_altaremotaempresa_01.jpg")no-repeat center center').css('background-size', 'cover');
  }
  else if (slide == 'tarjetas') {
    $('.owl-stage').trigger('to.owl.carousel', [1, 1]);
    // $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190212_altaremotaempresa_02.jpg")no-repeat center center').css('background-size', 'cover');
  }
  else if (slide == 'tpv') {
    $('.owl-stage').trigger('to.owl.carousel', [2, 1]);
    // $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190528_altaremotaempresa_03.jpg")no-repeat center center').css('background-size', 'cover');
  }
  else if (slide == 'financiacion') {
    $('.owl-stage').trigger('to.owl.carousel', [3, 1]);
    // $('.background').css('background', 'url("https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/190506_altaremotaempresa_04.jpg")no-repeat center center').css('background-size', 'cover');
  }
  $('#email').mailtip({
    mails: ['gmail.com', 'hotmail.com', 'hotmail.es'],
    offsetTop: -1,
    offsetLeft: 0,
    zIndex: 10,
  });

  $('form').on('reset', function () {
    setTimeout(() => {
      $('input, select')
        .each(function () {
          $(this).change();
        });
    }, 100);
  });
  $('.has-float-label input, .has-float-label select')
    .each(function () {
      if ($(this).val()) {
        $(this).addClass('has-value');
      }
    })
    .on('focus', function () {
      $(this).addClass('is-focused');
    })
    .on('blur', function () {
      if ($(this).val()) {
        $(this).addClass('has-value');
      }
      else {
        $(this).removeClass('has-value');
      }
      $(this).removeClass('is-focused');
    });

  const customData = {
    'form': {
      'form_altaremotanegocio': {
        'name': 'form_altaremotanegocio',
        'fields': [{
          'name': 'id_num',
          'validations': {
            'required': true,
            'nifnie': true,
          },
        }, {
          'name': 'tipo_segmento',
          'validations': {
            'required': true,
          },
        }, {
          'name': 'genero',
          'validations': {
            'required': true,
          },
        }, {
          'name': 'phone',
          'validations': {
            'required': true,
            'phone': true,
          },
        }, {
          'name': 'cp',
          'validations': {
            'required': true,
            'number':true,
            'minlength': 5,
            'maxlength': 5,
            'cp': true,
          },
        }, {
          'name': 'numero_oficina',
          'validations': {
            'required': true,
            'office': true,
          },
        }, {
          'name': 'day',
          'validations': {
            'required': true,
          },
        }, {
          'name': 'name',
          'validations': {
            'required': true,
            'lettersonly': true,
            'minlength': 2,
          },
        }, {
          'name': 'email',
          'validations': {
            'required': true,
            'customEmail': true,
          },
        }, {
          'name': 'lopd',
          'validations': {
            'required': true,
          },
        }, {
          'name': 'selectores',
          'validations': {
            'required': true,
            'selectores': true,
          },
        }],
      },
    },
  };
  const Hashes = require('jshashes');

  //const locationsData = require('../assets/locations.json');

  let locationsData = [];
  $.getJSON('https://us-central1-bs-marketing-api.cloudfunctions.net/getOffices', function (json) {
    locationsData.push.apply(locationsData, json);
  });

  const GoogleMaps = {
    apiKey: '',

    load: function (apiKey) {
      console.log('GoogleMaps load');
      this.apiKey = apiKey;
      this.injectGoogleApis();
    },

    injectGoogleApis: function () {
      console.log('GoogleMaps injectGoogleApis');
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?' + this.apiKey + '&callback=handleGoogleApisInitialized&libraries=geometry';
      script.defer = true;
      script.async = true;

      document.getElementsByTagName('body')[0].appendChild(script);
    },
  };

  /*   const assetsGuids = {
      "icons": {
        "map_marker": "https://images.comunicaciones.bancsabadell.com/EloquaImages/clients/BANCODESABADELLSA/%7Be70d92f0-cd46-4c27-b78e-dafe439babae%7D_map_marker-icon.png",
        "geolocation": "https://images.comunicaciones.bancsabadell.com/EloquaImages/clients/BANCODESABADELLSA/%7Bd50e85a8-91c3-46a1-afae-7688a7803f96%7D_geolocation-icon.png",
        "offices_search": "https://images.comunicaciones.bancsabadell.com/EloquaImages/clients/BANCODESABADELLSA/%7Ba0773b66-55e8-40c2-ad51-9be1d69d6ac1%7D_searching_offices-icon.png"
      }
    }; */

  const assetsGuids = {
    'icons': {
      'map_marker': 'https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/map_marker-icon.png',
      'geolocation': 'https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/geolocation-icon.png',
      'offices_search': 'https://www.bancsabadell.com/SIMPLEBANK/AltaCliente_Negocio/images/searching_offices-icon.png',
    },
  };

  const EloquaAssets = {
    guids: {},

    setGuids: function () {
      this.guids = assetsGuids;
    },

    allset: function () {
      return $.when(this.setGuids());
    },
  };

  const officesMapMsgs = {
    'ca': {
      'geocalising': 'Estem localitzant la teva ubicació...',
      'searching_offices': 'Estem fent la cerca de les oficines més properes...',
      'geolocation_denied': 'Sembla que el teu navegador no permet fer ús del servei de localització. Procedeix a habilitar el servei de localització en el teu navegador per poder trobar oficines a prop teu.',
      'no_results': 'Ho sentim, no existeix cap oficina registrada en aquesta zona.<br>Si us plau, busqui en un altre zona.',
      'thrown_error': 'Ho sentim, hi ha hagut un error amb la càrrega d\'oficines.<br>Si us plau, torna-ho a intentar.',
      'expand_results': 'Veure més',
      'narrow_results': 'Veure menys',
    },
    'es': {
      'geocalising': 'Estamos localizando tu ubicación...',
      'searching_offices': 'Buscando las oficinas más cercanas...',
      'geolocation_denied': 'Parece que tu navegador no permite utilizar el servicio de localización. Procede a habilitar el servicio de localización en tu navegador para que podamos encontrar oficinas cerca tuyo.',
      'no_results': 'Lo sentimos, no hay ninguna oficina registrada en esta zona.<br>Por favor, busque en otra zona.',
      'thrown_error': 'Lo sentimos, se ha producido un error en la carga de oficinas.<br>Por favor intenta nuevamente.',
      'expand_results': 'Ver más',
      'narrow_results': 'Ver menos',
    },
    'en': {
      'geocalising': 'Initiating geolocation...',
      'searching_offices': 'Initiating search of nearest offices...',
      'geolocation_denied': 'It seems your browser does not allow providing your location. Please proceed to enable geolocation in your browser so we can show the offices located in your area.',
      'no_results': 'We apologise, there\'s no offices registered in this place.<br>Please, try again.',
      'thrown_error': 'We apologise, there\'s been an error trying to load the offices.<br>Please, try again.',
      'expand_results': 'See more',
      'narrow_results': 'See less',
    },
  };

  const OfficesMap = {
    map: {},
    geocoder: {},
    markers: [],
    apiKey: '',
    lang: '',
    isLoading: false,
    initialised: false,
    office_selected: false,
    map_settings: {
      zip_zoom: 12,
    },
    officesPerPage: 3,

    init: function () {
      console.log('OfficesMap init');
      this.initialised = true;

      this.map = new google.maps.Map(document.getElementById('offices-map'), {
        scrollwheel: false,
        streetViewControl: false,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
      });
      this.map.addListener('idle', function () {
        // 3 seconds after the center of the map has changed, pan back to the marker.
        window.setTimeout(function () {
          OfficesMap.setOfficesByZip();
        }, 1000);
      });
    },

    load: function (apiKey, lang) {
      console.log('OfficesMap load');
      this.apiKey = apiKey;
      this.lang = lang;
      this.messages = officesMapMsgs[lang];
    },

    toggleInputControl: function () {
      console.log('toggleInputControl');
      this.isLoading = !this.isLoading;
      const $inputControl = $('#cp');
      let disabledValue = (!(typeof $inputControl.attr('disabled') !== undefined && $inputControl.attr('disabled') !== false));
      $inputControl.prop('disabled', disabledValue);
    },

    setMapByZip: function (cp) {
      console.log('setMapByZip');

      const $offices = $('.form-field-group-offices');
      $offices.removeClass('collapsed');

      this.isLoading = true;

      $.ajax({
        method: 'GET',
        url: 'https://maps.googleapis.com/maps/api/geocode/json?' + this.apiKey + '&components=country:ES|postal_code:' + cp + '&language=' + this.lang,
        dataType: 'JSON',
      })
        .done(function (data) {
          if (data.status === 'ZERO_RESULTS') {
            OfficesMap.initGeolocation();
          }
          else if ((data.status === 'OK')) {
            console.log(data);
            let isCP;
            data.results[0]['address_components'].every(
              function (element, index) {
                isCP = (cp === element['long_name']);
                if ((cp === element['long_name'])) {
                  console.log('a[' + index + '] = ' + element['long_name']);
                  if (!OfficesMap.initialised) OfficesMap.init();
                  OfficesMap.map_settings.position = {
                    lat: data.results[0]['geometry'].location.lat,
                    lng: data.results[0]['geometry'].location.lng,
                  };
                  OfficesMap.map.setCenter(OfficesMap.map_settings.position);
                  OfficesMap.map.setZoom(OfficesMap.map_settings.zip_zoom);
                  return false;
                }
              },
            );
            if (!isCP) {
              OfficesMap.initGeolocation();
            }
          }
          else {
            OfficesMap.initGeolocation();
          }
        })
        .fail(function () {
          OfficesMap.toggleInputControl();
          OfficesMap.showThrownError();
        });

    },

    initGeolocation: function () {

      console.log('initGeolocation');
      this.showGelocalisingMsg();
      if (navigator.geolocation) {
        function geolocationSuccess(position) {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          OfficesMap.map_settings.user_position = {
            lat: lat,
            lng: lng,
          };

          $.ajax({
            method: 'GET',
            url: 'https://maps.googleapis.com/maps/api/geocode/json?' + OfficesMap.apiKey + '&latlng=' + lat + ',' + lng,
            dataType: 'JSON',
          })
            .done(function (data) {
              if (data.status === 'ZERO_RESULTS') {
                OfficesMap.toggleInputControl();
                OfficesMap.showThrownError();
              }
              else if (data.status === 'OK') {
                OfficesMap.hideMapMsg();
                let geolocatedZip = null;
                $.each(data.results[0]['address_components'], function (index, item) {
                  geolocatedZip = item.types[0] === 'postal_code' ? item['long_name'] : null;
                });
                OfficesMap.setMapByZip(geolocatedZip);
              }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
              console.log(textStatus.toUpperCase() + ' | Google map By GEOLOCATION COORDS | ' + errorThrown);
              OfficesMap.toggleInputControl();
              OfficesMap.showThrownError();
            });
        }

        function geolocationError(error) {
          console.log(error.code + ' | ' + error.message);
          OfficesMap.toggleInputControl();
          OfficesMap.showThrownError();
        }

        const geolocationOptions = {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 60000,
        };

        navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, geolocationOptions);
      }
      else {
        this.toggleInputControl();
        this.showGeolocationDenied();
      }
    },
    //Geolocation on Document ready
    searchNearOffices: function () {

      console.log('searchNearOffices');
      this.showGelocalisingMsg();
      const $offices = $('.form-field-group-offices');
      $offices.removeClass('collapsed');
      if (navigator.geolocation) {


        function geolocationSuccess(position) {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          const latlng = lat + ', ' + lng;

          console.log('geolocationSuccess', lat, lng);
          $.ajax({
            method: 'GET',
            url: 'https://maps.googleapis.com/maps/api/geocode/json?' + OfficesMap.apiKey + '&latlng=' + lat + ',' + lng,
            dataType: 'JSON',
          })
            .done(function (data) {
              console.log('searchNearOffices done', data);
              if (data.status === 'OK') {

                const distanceList = [];

                if (locationsData.length) {
                  for (let i = 0; i < locationsData.length; i++) {
                    let p1 = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    let p2 = new google.maps.LatLng(locationsData[i].lat.replace(/,/g, '.'), locationsData[i].lng.replace(/,/g, '.'));
                    let distance = OfficesMap.calcDistance(p1, p2);
                    distance = parseInt(distance);
                    distanceList.push(distance);
                  }

                  const distanceMin = Math.min.apply(Math, distanceList);
                  const minPosition = distanceList.indexOf(distanceMin);

                  const destlatlang = locationsData[minPosition].lat.replace(/,/g, '.') + ', ' + locationsData[minPosition].lng.replace(/,/g, '.');
                  OfficesMap.getDistanceMatrix(latlng, destlatlang, locationsData[minPosition]);
                }
                else {
                  console.log('Error: No existen oficinas dentro de tu Ciudad');
                }
              }
            })
            .fail(function () {
              console.log('fail');
            });
        }

        function geolocationError(error) {
          console.log(error.code + ' | ' + error.message);
        }

        const geolocationOptions = {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 60000,
        };

        navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, geolocationOptions);

      }
      else {
        console.log('<p>Geolocation is not supported by your browser</p>');
      }
    },
    calcDistance: function (p1, p2) {
      return (google.maps.geometry.spherical.computeDistanceBetween(p1, p2).toFixed(2));
    },
    getDistanceMatrix: function (origins, destinations, office) {
      console.log('getDistanceMatrix', origins, destinations, office);
      let service = new google.maps.DistanceMatrixService();

      function callback(response) {

        if (response.rows[0].elements[0]['distance'].text) {
          const showMap = $('#hideGeolocation');
          OfficesMap.setOfficeID(office['codofi']);
          OfficesMap.setOfficeDetails(office.address, office.name, office.lat, office.lng);
          $('#form_altaremotanegocio').addClass('geolocation');
          $('#distance').html(response.rows[0].elements[0]['distance'].text);
          $('#officeName').html(office.name);
          $('#officeLocation').html(office.address);
          $(showMap).unbind('click');
          $(showMap).bind('click', function () {
            $('#form_altaremotanegocio').removeClass('geolocation');
            console.log('click showMap');
            OfficesMap.initGeolocation();
          });
        }

      }

      service.getDistanceMatrix({
        origins: [origins],
        destinations: [destinations],
        travelMode: 'DRIVING',
      }, callback);

    },

    setOfficesByZip: function () {
      console.log('setOfficesByZip');

      console.log(OfficesMap.map.getBounds());

      this.showSearchingOfficesgMsg();
      let bounds = OfficesMap.map.getBounds();
      let locationsInViewport = [];
      for (let office of locationsData) {
        if (bounds.contains({
          lat: parseFloat(office.lat.replace(/,/g, '.')),
          lng: parseFloat(office.lng.replace(/,/g, '.')),
        })) {
          // code for showing your object, associated with markers[i]

          locationsInViewport.push(office);
          //this.markersMap.push(office);
        }
      }

      if (locationsInViewport.length > 0) {
        this.setOfficesMapMarkers(locationsInViewport);
        this.setOfficesSelect(locationsInViewport);
        this.hideMapMsg();
      }
      else {
        this.showNoResultsMsg();
        this.toggleInputControl();
      }
    },

    setOfficesMapMarkers: function (offices) {
      console.log('setOfficesMapMarkers', offices);
      if (this.markers.length) {
        this.clearMarkers();
        this.markers = [];
      }
      $.each(offices, function (index, office) {
        let marker = new google.maps.Marker({
          position: {
            lat: parseFloat((office.lat).replace(',', '.')),
            lng: parseFloat((office.lng).replace(',', '.')),
          },
          map: OfficesMap.map,
          icon: EloquaAssets.guids.icons.map_marker,
          animation: google.maps.Animation.DROP,
          custom_info: {
            id: office['codofi'],
            ine: office['codine'],
            address: office.address + ', ' + office['postal'] + ', ' + office.city,
            name: office.name,
            lat: office.lat,
            lng: office.lng
          },
        });

        marker.addListener('click', OfficesMap.handleClickOnMarker);
        OfficesMap.markers.push(marker);
      });
    },

    // Click on Map office
    handleClickOnMarker: function () {
      console.log('handleClickOnMarker');
      $('.offices-select-option').removeClass('selected');
      const $selectedOffice = $('.offices-select-option[data-id=\'' + this.custom_info.id + '\']');
      $selectedOffice.addClass('selected');

      if ($selectedOffice.closest('.offices-select-page').hasClass('collapsed')) {
        OfficesMap.toggleMoreLessResultsTrigger.trigger('click');
      }

      OfficesMap.setOfficeID(this.custom_info.id);
      OfficesMap.setOfficeDetails(this.custom_info.address, this.custom_info.name, this.custom_info.lat, this.custom_info.lng);
      OfficesMap.office_selected = true;
    },

    setOfficeID: function (officeId) {
      const numeroOficina = $('#numero_oficina');
      console.log('setOfficeID', officeId);
      numeroOficina.val(officeId);
      numeroOficina.valid();
    },

    setOfficeDetails: function (officeAddress, officeName, lat, lng) {
      console.log('setOfficeDetails', officeAddress, officeName);
      $('#direccion_oficina').val(officeAddress);
      $('#nombre_oficina').val(officeName);
      $('#office_lat').val(lat);
      $('#office_lng').val(lng);
    },

    clearMarkers: function () {
      console.log('clearMarkers');
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
    },

    setOfficesSelect: function (offices) {

      console.log('setOfficesSelect');
      let isPaginated = offices.length > this.officesPerPage;

      let $list = '';

      $.each(offices, function (index, office) {
        $list += isPaginated && (index % OfficesMap.officesPerPage) === 0 ? '<div class=\'offices-select-page offices-select-page-' + index / OfficesMap.officesPerPage + ' ' + (index !== 0 ? 'collapsed' : '') + '\'>' : '';
        $list += '<div class=\'offices-select-option\' data-key=' + index + ' data-id=' + office['codofi'] + '><h1>' + office.name + '</h1><p>' + office.address + ', ' + office['postal'] + ', ' + office.city + '</p></div>';
        $list += (isPaginated && ((index + 1) % OfficesMap.officesPerPage) === 0) || (isPaginated && (index + 1 === offices.length)) ? '</div>' : '';
      });

      $list += isPaginated ? '<div class=\'offices-select-pages-toggle float-right\'><a href=\'#none\' id=\'toggle-results_trigger\'>' + this.messages.expand_results + '</a></div>' : '';

      $('#offices-select').html($list);

      if (isPaginated) {
        this.toggleMoreLessResultsTrigger = $('#toggle-results_trigger');
        this.initToggleMoreLessResultsTrigger();
      }

      this.initHandleClickOnOfficeOption();

      this.toggleInputControl();
    },

    initToggleMoreLessResultsTrigger: function () {
      console.log('initToggleMoreLessResultsTrigger');
      this.toggleMoreLessResultsTrigger.on('click', function () {
        $('.offices-select-page').not('.offices-select-page-0').toggleClass('collapsed');
        OfficesMap.toggleMoreLessResultsTrigger.text(OfficesMap.toggleMoreLessResultsTrigger.text() === OfficesMap.messages.expand_results ? OfficesMap.messages.narrow_results : OfficesMap.messages.expand_results);
      });
    },

    initHandleClickOnOfficeOption: function () {
      console.log('initHandleClickOnOfficeOption');
      const $officeSelectOption = $('.offices-select-option');
      $officeSelectOption.on('click', function () {
        google.maps.event.trigger(OfficesMap.markers[$(this).data('key')], 'click');
      });
    },

    showGelocalisingMsg: function () {
      const officesMap = $('#offices-map');
      console.log('showGelocalisingMsg');
      officesMap.find('.msg').remove();
      const $msg = $('<div class=\'msg fade-in\'><p><img alt="search" src=\'' + EloquaAssets.guids.icons.geolocation + '\' /><span>' + this.messages.geocalising + '</span></p></div>');
      officesMap.append($msg);
    },

    showGeolocationDenied: function () {
      const officesMap = $('#offices-map');
      console.log('showGeolocationDenied');
      officesMap.find('.msg').remove();
      const $msg = $('<div class=\'msg fade-in\'><p>' + this.messages.geolocation_denied + '</span></p></div>');
      officesMap.append($msg);
    },

    showSearchingOfficesgMsg: function () {
      const officesMap = $('#offices-map');
      console.log('showSearchingOfficesgMsg');
      officesMap.find('.msg').remove();
      const $msg = $('<div class=\'msg fade-in\'><p><img alt="search" src=\'' + EloquaAssets.guids.icons.offices_search + '\' /><span>' + this.messages.searching_offices + '</span></p></div>');
      officesMap.append($msg);
    },

    hideMapMsg: function () {
      console.log('hideMapMsg');
      $('#offices-map').find('.msg').remove();
    },

    showNoResultsMsg: function () {

      console.log('showNoResultsMsg');
      const $selectMsg = '<div class=\'offices-select-no-results\'><p>' + this.messages.no_results + '</p></div>';
      $('#offices-select').html($selectMsg);
      $('#offices-map').find('.msg').remove();
      //const $msg = $('<div class=\'msg fade-in\'><p>' + this.messages.no_results + '</span></p></div>');
      //$('#offices-map').append($msg);
    },

    showThrownError: function () {
      const officesMap = $('#offices-map');
      console.log('showThrownError');
      officesMap.find('.msg').remove();
      const $msg = $('<div class=\'msg fade-in\'><p>' + this.messages.thrown_error + '</p></div>');
      officesMap.append($msg);
    },
  };

  const validationsMsgs = {
    'ca': {
      'msg-required': 'Aquest camp és obligatori.',
      'msg-email': 'L\'adreça electrònica no és vàlida.',
      'msg-nifnie': 'El document no és vàlid. ',
      'msg-phone': 'El número de telèfon no és vàlid.',
      'msg-cp': 'El codi postal no és vàlid.',
      'msg-threedaysavailability': 'La disponibilitat de la cita no és possible fins d\'aquí a tres dies.',
      'msg-onlyweekdays': 'La data escollida no pot ser en cap de setmana.',
      'msg-officeavailability': 'Aquesta oficina tanca en la data escollida.',
      'msg-alphabetonly': 'Aquest camp ha de tenir només lletres.',
      'msg-digits': 'Aquest camp ha de tenir només números.',
      'msg-accept': 'Has d\'acceptar les condicions de contratació per a poder seguir endavant.',
      'msg-office': 'Has d\'escollir una oficina.',
      'msg-maxlength': 'Aquest camp ha de tenir un màxim de {0} caracters.',
      'msg-minlength': 'Aquest camp ha de tenir un mínim de {0} caracters.',
    },
    'es': {
      'msg-required': 'Este campo es obligatorio.',
      'msg-email': 'El correo electrónico no es válido.',
      'msg-nifnie': 'El documento no es válido.',
      'msg-phone': 'El número de teléfono no es válido.',
      'msg-cp': 'El código postal no es válido.',
      'msg-threedaysavailability': 'La disponibilidad de la cita no es posible hasta dentro de tres días.',
      'msg-onlyweekdays': 'La fecha escogida no puede ser en fin de semana.',
      'msg-officeavailability': 'Esta oficina no abre en la fecha escogida.',
      'msg-alphabetonly': 'Este campo debe contener sólo letras.',
      'msg-digits': 'Este campo debe contener sólo dígitos.',
      'msg-accept': 'Debes aceptar las condiciones y términos.',
      'msg-office': 'Debes seleccionar una oficina.',
      'msg-maxlength': 'Debe contener más de {0} caracteres.',
      'msg-minlength': 'Debe contener al menos {0} caracteres.',
    },
    'en': {
      'msg-required': 'This field must be filled.',
      'msg-email': 'The e-mail is not valid.',
      'msg-nifnie': 'The ID is not valid. ',
      'msg-phone': 'The phone number is not valid.',
      'msg-cp': 'The ZIP number is not valid.',
      'msg-threedaysavailability': 'The availability of chosen dates is three days from now.',
      'msg-onlyweekdays': 'The appointment date does not include weekends.',
      'msg-officeavailability': 'This office closes the chosen date.',
      'msg-alphabetonly': 'This field must be filled with letters only.',
      'msg-digits': 'This field must be filled with digits only.',
      'msg-accept': 'You must accept terms and conditions to proceed.',
      'msg-office': 'You must choose an office.',
      'msg-maxlength': 'This field must be filled with no more than {0} characters.',
      'msg-minlength': 'This field must be filled with {0} caracters at least.',
    },
  };


  const Validations = {
    messages: {},
    formValidation: {},

    init: function () {
      this.setMessages();
      this.setFormValidations();
      this.addValidationMethods();
    },

    load: function (lang) {
      this.messages = validationsMsgs[lang];
      this.loadValidationsData();
    },

    loadValidationsData: function () {
      this.formValidation = customData.form.form_altaremotanegocio;
      this.init();
    },

    setMessages: function () {
      $.extend($.validator.messages, {
        required: this.messages['msg-required'],
        // remote: "Please fix this field.",
        email: this.messages['msg-email'],
        // url: "Please enter a valid URL.",
        date: 'Please enter a valid date.',
        dateISO: 'Please enter a valid date (ISO).',
        // number: "Please enter a valid number.",
        digits: this.messages['msg-digits'],
        // creditcard: "Please enter a valid credit card number.",
        // equalTo: this.messages['msg-equalto'],
        accept: this.messages['msg-accept'],
        maxlength: $.validator.format(this.messages['msg-maxlength']),
        minlength: $.validator.format(this.messages['msg-minlength']),
        // rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
        // range: $.validator.format("Please enter a value between {0} and {1}."),
        max: $.validator.format('Please enter a value less than or equal to {0}.'),
        min: $.validator.format('Please enter a value greater than or equal to {0}.'),
      });
    },

    setFormValidations: function () {
      let formValidationRules = {};

      $.each(this.formValidation.fields, function (key, value) {
        formValidationRules[value.name] = value.validations;
      });

      $('#' + this.formValidation.name).submit(function (e) {
        console.log('TO VALIDATE : ', JSON.stringify(formValidationRules, undefined, 2));
        e.preventDefault();
      }).validate({
        ignore: ':hidden:not(.to-validate)',
        rules: $.extend(true, {}, formValidationRules),
        errorPlacement: function (error, element) {
          if (element.attr('name') === 'lopd') {
            error.addClass('mt-50');
            element.parent('label').after(error);
          }
          else if (element.attr('name') === 'info_extra[]') {
            element.parents('.form-field-group').after(error);
          }
          else if (element.attr('name') === 'genero') {
            element.parents('.form-field-group-radiobuttons').after(error);
          }
          else {
            element.next('.placeholder').after(error);
          }
        },
        submitHandler: function (form) {
          // If previously submitted - don't submit again
          if ($(form).data('submitted') !== true) {
            if ($(form).find('input[name=\'info_extra[]\']').length) {
              const $checks = $('input[name=\'info_extra[]\']:checked');
              let interests = '';
              $checks.each(function (i) {
                let comma = i === 0 ? '' : ',';
                interests += comma + $(this).val();
              });
              $(form).find('input[name=\'info_extra\']').val(interests);
            }
            if ($(form).find('input[name=\'id_cita\']').length) {
              const emailVal = $(form).find('input[name=\'email\']').val();
              const idCitaVal = new Hashes.RMD160().hex(emailVal) + '_' + Date.now();
              $(form).find('input[name=\'id_cita\']').val(idCitaVal);
              if(cookies.existCookie('AMCV0A43C2415798EF2E7F000101AdobeOrg')) {
                $(form).find('input[name=\'id_adobe\']').val(cookies.existCookie('AMCV0A43C2415798EF2E7F000101AdobeOrg').split('MCMID|')[1].split('|')[0]);
              }
              function pad(s) { return (s < 10) ? '0' + s : s; }
              const d = new Date();
              $(form).find('input[name=\'request_date_formatted\']').val([pad(d.getMonth()+1), pad(d.getDate()), d.getFullYear()].join('/'));
              $(form).find('input[name=\'request_date\']').val(d.getTime());
            }
            form.submit();
            // Mark it so that the next submit can be ignored
            $(form).data('submitted', true);
          }
        },
      });
    },

    getIdentificationDocumentType: function(str) {
      const NIF_REGEX = new RegExp('^(\\d{8})([TRWAGMYFPDXBNJZSQVHLCKE])');
      const CIF_REGEX = new RegExp('^([ABCDEFGHJKLMNPQRSUVW])(\\d{7})([0-9A-J])');
      const NIE_REGEX = new RegExp('^[XYZ]\\d{7,8}[TRWAGMYFPDXBNJZSQVHLCKE]');
      let type = '';
      if (str.match(NIF_REGEX)) {
        type = 'NIF';
      } else if (str.match(NIE_REGEX)) {
        type = 'NIE';
      } else if (str.match(CIF_REGEX)) {
        type = 'CIF';
      }
      return type;
    },

    isValidNIF: function(dni) {
      console.log('isValidNIF');
      const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
      const letter = dniLetters.charAt(parseInt(dni, 10) % 23);
      console.log(letter == dni.charAt(8));
      return letter == dni.charAt(8);
    },

    isValidNIE: function(nie) {
      // Change the initial letter for the corresponding number and validate as DNI
      let niePrefix = nie.charAt(0);

      switch (niePrefix) {
        case 'X':
          niePrefix = 0;
          break;
        case 'Y':
          niePrefix = 1;
          break;
        case 'Z':
          niePrefix = 2;
          break;
      }
      return Validations.isValidNIF(niePrefix + nie.substr(1));
    },

    isValidCIF: function(cif) {
      const match = cif.match('^([ABCDEFGHJKLMNPQRSUVW])(\\d{7})([0-9A-J])');
      const letter = match && match[1],
        number = match && match[2],
        control = match && match[3];

      let evenSum = 0;
      let oddSum = 0;
      let n;

      for (let i = 0; i < number.length; i++) {
        n = parseInt(number && number[i], 10);

        // Odd positions (Even index equals to odd position. i=0 equals first position)
        if (i % 2 === 0) {
          // Odd positions are multiplied first.
          n *= 2;

          // If the multiplication is bigger than 10 we need to adjust
          oddSum += n < 10 ? n : n - 9;

          // Even positions
          // Just sum them
        } else {
          evenSum += n;
        }
      }

      const controlDigit = Number((10 - (evenSum + oddSum).toString().substr(-1)).toString().substr(-1));
      const controlLetter = 'JABCDEFGHI'.substr(controlDigit, 1);

      // Control must be a digit
      if (letter.match(/[ABEH]/)) {
        return control == controlDigit;

        // Control must be a letter
      } else if (letter.match(/[KPQS]/)) {
        return control == controlLetter;

        // Can be either
      } else {
        return control == controlDigit || control == controlLetter;
      }
    },

    validateIdentificationDocument: function(value) {
      console.log(value);
      const str = value.toString().toUpperCase().replace('/s/', '');
      let isValid = false;
      const typeValidation = Validations.getIdentificationDocumentType(str);
      console.log(typeValidation);
      if (!typeValidation) return false;

      switch (typeValidation) {
        case 'NIF':
          isValid = Validations.isValidNIF(str);
          if (isValid) {
            Validations.setIdentificationType(typeValidation);
          }
          break;
        case 'NIE':
          isValid = Validations.isValidNIE(str);
          if (isValid) {
            Validations.setIdentificationType(typeValidation);
          }
          break;
        case 'CIF':
          isValid = Validations.isValidCIF(str);
          if (isValid) {
            Validations.setIdentificationType(typeValidation);
          }
          break;
      }
      return isValid;
    },

    setIdentificationType: function(type) {
      $('input#type_doc').remove();
      $('<input type="hidden" name="type_doc" id="type_doc" value="'+ type +'">').insertBefore('input#name');
    },

    addValidationMethods: function () {

      $.validator.addMethod('customEmail', function (value, element) {
        const regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return this.optional(element) || regex.test(value);
      }, this.messages['msg-email']);

      $.validator.addMethod('lettersonly', function (value, element) {
        return this.optional(element) || /^[a-zÀ-ú\s-]+$/i.test(value);
      }, this.messages['msg-alphabetonly']);

      $.validator.addMethod('nifnie', function (value, element) {
        const idDocTypeElmName = $(element).attr('name') + '_nifnie';
        const idDocType = $('input[name="' + idDocTypeElmName + '"]:checked').val();
        return this.optional(element) || Validations.validateIdentificationDocument(value);
      }, this.messages['msg-nifnie']);

      $.validator.addMethod('phone', function (value, element) {
        const phoneNumber = value.replace(/\s+/g, '');
        document.getElementById('phone').value = phoneNumber;
        return this.optional(element) || phoneNumber.match(/^[6-9]\d{8}$/);
      }, this.messages['msg-phone']); // Phone Number starting with the digits 6,7,8 or 9 and nine digits in total (Spain)

      $.validator.addMethod('cp', function (value, element) {
        const cpregex = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/;
        return this.optional(element) || cpregex.test(value);
      }, this.messages['msg-cp']); // CP number range between 01000 and 52999 (Spain)

      $.validator.addMethod('office', function (value) {
        if (OfficesMap.isLoading) {
          return value !== '';
        }
        return true;
      }, this.messages['msg-office']); // Office code assigned
    },
  };

  const Utils = {
    isDevEnv: function () {
      return (window.location.href.indexOf(EloquaAssets.guids['PREPROD_DOMAIN']) === -1) && (window.location.href.indexOf(EloquaAssets.guids['PROD_DOMAIN']) === -1);
    },
  };

  const App = {
    currentLang: $('html').attr('xml:lang') ? $('html').attr('xml:lang') : $('html').attr('lang'),

    onGAPIReady: function () {
      console.log('onGAPIReady');
    },
    onReady: function () {
      if($('#form_altaremotanegocio')[0]){
        $('#form_altaremotanegocio')[0].reset();
      }
      const checkboxAccept = $('.checkbox-accept');
      if ($('#cp').length) {
        this.initMapOfficesTrigger();
      }
      if (checkboxAccept.length) {
        this.initCheckboxAccept();
        if ($('input[type=checkbox]').prop('checked')) {
          console.log('if');
          checkboxAccept.addClass('checked');
        }
        else {
          checkboxAccept.removeClass('checked');
        }
      }
      this.initSubmitBtn();
      this.setPublicAssets();
    },
    setPublicAssets: function () {
      $.when(EloquaAssets.allset()).then(function () {
        App.loadConfig();
      });
    },
    loadConfig: function () {
      console.log('App.loadConfig');
      const configData = {
        'locales': {
          'ca': 'ca-ES',
          'es': 'es-ES',
          'en': 'en-EN',
        },
        'gmaps_apiKey': {
          'DEV_ENV': 'key=AIzaSyBCPdDLjB-mSnwB5sjqsWSUKrXruzkTroU',
          'PROD_ENV': 'key=AIzaSyBCPdDLjB-mSnwB5sjqsWSUKrXruzkTroU',
        },
      };
      const Config = {
        load: function () {
          return configData;
        },
      };
      $.when(Config.load()).then(function (data) {
        let env = Utils.isDevEnv() ? 'DEV_ENV' : 'PROD_ENV';
        Validations.load(App.currentLang);
        GoogleMaps.load(data['gmaps_apiKey'][env]);
        if ($('#offices-map').length) {
          OfficesMap.load(data['gmaps_apiKey'][env], App.currentLang);
        }
      });
    },
    initCheckboxAccept: function () {
      $('.checkbox-accept').find('[type=checkbox]').on('change', function () {
        if ($('input[type=checkbox]').prop('checked')) {
          $('.checkbox-accept').addClass('checked');
        }
        else {
          $('.checkbox-accept').removeClass('checked');
        }
      });
    },
    initMapOfficesTrigger: function () {
      let timer;
      $('#cp').on('keyup', function (e) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          App.handleOfficesMap(e.target.value);
        }, 500);
      });

      $('.form-group-icon').on('click', function () {
        App.handleOfficesMap($('#cp').val());
      });
      $('#searchNearOffice').on('click', function () {
        OfficesMap.searchNearOffices();
      });
    },
    initSubmitBtn: function () {

    },
    handleOfficesMap: function (cp) {
      if ($('#cp').valid() && !OfficesMap.isLoading) {
        OfficesMap.setMapByZip(cp);
      }
    },
  };

  $(document).on('ready', App.onReady());

  window.handleGoogleApisInitialized = function () {
    App.onGAPIReady();
  };
});
